import { RoomStore } from './RoomStore';
import { RunTypeStore } from './RunTypeStore';
import { ShiftTimingStore } from './ShiftTimingsStore';
import { CoatingTypeStore } from './CoatingTypeStore';
import { StatusCodesStore } from './StatusCodesStore';
import { CleanTimeStore } from './CleanTimeStore';
import { DrugReferenceFgNdcStore } from './DrugReferenceFgNdcStore';
import { DrugReferenceFgNdcToBulkNdcStore } from './DrugReferenceFgNdcToBulkNdcStore';
import { DrugReferenceByConceptCodeStore } from './DrugReferenceByConceptCodeStore';
import { CleanTypeStore } from './CleanTypeStore';
import { DefaultBpmByPillCountStore } from './DefaultBpmByPillCountStore';
import { StandardAndRecipeBpmStore } from './StandardAndRecipeBpmStore';
import { RoomBpmByRunTypeStore } from './RoomBpmByRunTypeStore';
import { BpmByNdcAndJobTypeStore } from './BpmByNdcAndJobTypeStore';

import { ClearTimeStore } from './ClearTimeStore';
import { SetupTimeStore } from './SetupTimeStore';
import { LvTimeStore } from './LvTimeStore';

// Initialize all reference stores
export const roomStore = new RoomStore();
export const shiftTimingStore = new ShiftTimingStore();
export const runTypeStore = new RunTypeStore();
export const coatingTypeStore = new CoatingTypeStore();
export const statusCodesStore = new StatusCodesStore();
export const cleanTimeStore = new CleanTimeStore();
export const cleanTypeStore = new CleanTypeStore();
export const drugReferenceFgNdcStore = new DrugReferenceFgNdcStore();
export const drugReferenceFgNdcToBulkNdcStore = new DrugReferenceFgNdcToBulkNdcStore();
export const drugReferenceByConceptCodeStore = new DrugReferenceByConceptCodeStore();
export const defaultBpmByPillCountStore = new DefaultBpmByPillCountStore();
export const standardAndRecipeBpmStore = new StandardAndRecipeBpmStore();
export const roomBpmByRunTypeStore = new RoomBpmByRunTypeStore();
export const bpmByNdcAndJobTypeStore = new BpmByNdcAndJobTypeStore();

export const clearTimeStore = new ClearTimeStore();
export const setupTimeStore = new SetupTimeStore();
export const lvTimeStore = new LvTimeStore();

// Export store classes for reinitialization
export { RoomStore } from './RoomStore';
export { RunTypeStore } from './RunTypeStore';
export { ShiftTimingStore } from './ShiftTimingsStore';
export { CoatingTypeStore } from './CoatingTypeStore';
export { StatusCodesStore } from './StatusCodesStore';
export { CleanTimeStore } from './CleanTimeStore';
export { CleanTypeStore } from './CleanTypeStore';
export { DrugReferenceFgNdcStore } from './DrugReferenceFgNdcStore';
export { DrugReferenceFgNdcToBulkNdcStore } from './DrugReferenceFgNdcToBulkNdcStore';
export { DrugReferenceByConceptCodeStore } from './DrugReferenceByConceptCodeStore';
export { DefaultBpmByPillCountStore } from './DefaultBpmByPillCountStore';
export { StandardAndRecipeBpmStore } from './StandardAndRecipeBpmStore';
export { RoomBpmByRunTypeStore } from './RoomBpmByRunTypeStore';
export { BpmByNdcAndJobTypeStore } from './BpmByNdcAndJobTypeStore';

export { ClearTimeStore } from './ClearTimeStore';
export { SetupTimeStore } from './SetupTimeStore';
export { LvTimeStore } from './LvTimeStore';

// Optional type for all reference stores
export interface IReferenceStores {
  roomStore: RoomStore;
  shiftTimingStore: ShiftTimingStore;
  runTypeStore: RunTypeStore;
  coatingTypeStore: CoatingTypeStore;
  statusCodesStore: StatusCodesStore;
  cleanTimeStore: CleanTimeStore;
  cleanTypeStore: CleanTypeStore;
  drugReferenceFgNdcStore: DrugReferenceFgNdcStore;
  drugReferenceFgNdcToBulkNdcStore: DrugReferenceFgNdcToBulkNdcStore;
  drugReferenceByConceptCodeStore: DrugReferenceByConceptCodeStore;
  defaultBpmByPillCountStore: DefaultBpmByPillCountStore;
  standardAndRecipeBpmStore: StandardAndRecipeBpmStore;
  roomBpmByRunTypeStore: RoomBpmByRunTypeStore;
  bpmByNdcAndJobTypeStore: BpmByNdcAndJobTypeStore;
  clearTimeStore: ClearTimeStore;
  setupTimeStore: SetupTimeStore;
  lvTimeStore: LvTimeStore;
}
